import { BE_ADMIN_BASE } from "./environment";
import { apiGet, apiPost } from "./apiClient";

// Airline carry-on baggage admin CRUD.
// Gateway: /app/v1/beadmin/airline-carryon*  ->  engine: /be/v1/admin/airline-carryon*
// Encrypted body/response + JWT are handled by apiClient.

// List (paginated). params: { limit (1..1000), lastKey? }
export const getAirlineCarryOnListAPI = (params, opts) =>
  apiGet(`${BE_ADMIN_BASE}/airline-carryon`, { ...opts, params });

// Create. payload: { airlineCode, airlineName, carryOnBaggage: { KG, LB } }
export const saveAirlineCarryOnAPI = (payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/airline-carryon/save`, payload, opts);

// Update weights. code = 2-char airline code (URL); payload: { carryOnBaggage: { KG?, LB? } }
export const updateAirlineCarryOnAPI = (code, payload, opts) =>
  apiPost(
    `${BE_ADMIN_BASE}/airline-carryon/update/${encodeURIComponent(code)}`,
    payload,
    opts
  );
